import { useState } from 'react'

import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'

const useRefreshBalance = () => {
  const setBalance = useBoundStore(state => state.user.setBalance)
  const [isLoading, setIsLoading] = useState(false)

  const refreshBalance = async () => {
    // Guests have no wallet — the endpoint just answers 401. Read imperatively
    // so callers that mount pre-login still see a fresh value post-login.
    if (!useBoundStore.getState().user.username) return
    setIsLoading(true)
    try {
      const response = await api.post<
        ApiResponse<{
          balance: number
          promo_balance: number
          show_balance: number
          note: string | null
          wagering: {
            current: null | number
            target: null | number
            status: number
            is_completed: number
          }
        }>
      >('/ajax_data.php', {
        gameid: 0,
        type: 'get_balance',
        wallet_id: location.pathname.includes('/sports/im')
          ? 2
          : location.pathname.includes('/sports')
          ? 3
          : location.pathname.includes('/casino/')
          ? 1
          : null,
      })
      const { status, info } = response.data
      if (status === 1) {
        setBalance(info)
      }
    } catch (error) {
      console.error(error)
    }
    setIsLoading(false)
  }

  return { refreshBalance, isLoading }
}

export default useRefreshBalance
